import { Wordmark } from "./Nav";
import { scrollToId } from "../lib/stageState";

const BARS = [9, 14, 6, 12, 8, 15, 5, 11];

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-white/20">
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 grid md:grid-cols-12 gap-8 items-start">
      <div className="md:col-span-5">
        <Wordmark />
        <p className="mt-4 text-sm text-[color:var(--axt-text-dim)] max-w-sm">
          Capital calls, fees, waterfalls, and investor reporting run by AI agents and approved by senior fund accountants. Closed in minutes, not days.
        </p>
      </div>
      <div className="md:col-span-4 grid grid-cols-2 gap-6 text-sm">
        <div>
          <p className="axt-eyebrow mb-3">Explore</p>
          <ul className="space-y-2">
            {[
              ["story", "The story"],
              ["services", "Services"],
              ["trust", "Trust"],
              ["contact", "Join the waitlist"],
            ].map(([id, label]) => (
              <li key={id}>
                <button
                  type="button"
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollToId(id)}
                  className="text-[color:var(--axt-text-dim)] hover:text-[color:var(--axt-text)] transition-colors duration-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white/60 rounded-sm"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="axt-eyebrow mb-3">Contact</p>
          <ul className="space-y-2 text-[color:var(--axt-text-dim)]">
            <li>
              <a href="mailto:hello@axtara.ai" data-testid="footer-email-link" className="hover:text-[color:var(--axt-text)] transition-colors duration-200">
                hello@axtara.ai
              </a>
            </li>
            <li data-testid="footer-offices">Washington DC · London · New Delhi</li>
          </ul>
        </div>
      </div>
      <div className="md:col-span-3 md:text-right">
        <p className="font-mono-axt text-[10px] tracking-[0.18em] uppercase text-[color:var(--axt-text-faint)]">Chaos to Close</p>
        <p className="mt-2 text-xs text-[color:var(--axt-text-faint)]">&copy; {new Date().getFullYear()} AXTARA, Inc. All rights reserved.</p>
      </div>
    </div>

    {/* technical status strip */}
    <div className="border-t border-white/20 bg-black/40 backdrop-blur-sm" data-testid="footer-status-strip">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-2.5 flex items-center justify-between font-mono-axt text-[9px] tracking-[0.14em] text-white/50">
        <div className="flex items-center gap-3 lg:gap-6">
          <span className="hidden lg:inline">SYSTEM.ACTIVE</span>
          <span className="lg:hidden">SYS.ACT</span>
          <div className="hidden lg:flex items-end gap-1" aria-hidden="true">
            {BARS.map((h, i) => (
              <div key={i} className="w-1 bg-white/30" style={{ height: `${h}px` }} />
            ))}
          </div>
          <span>V1.0.0</span>
        </div>
        <div className="flex items-center gap-2 lg:gap-4">
          <span className="hidden lg:inline">◐ RENDERING</span>
          <div className="flex gap-1" aria-hidden="true">
            <div className="w-1 h-1 bg-white/60 rounded-full animate-pulse" />
            <div className="w-1 h-1 bg-white/40 rounded-full animate-pulse" style={{ animationDelay: "0.2s" }} />
            <div className="w-1 h-1 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: "0.4s" }} />
          </div>
          <span className="hidden lg:inline">FRAME: ∞</span>
        </div>
      </div>
    </div>
  </footer>
);
